import axios from 'axios';
import { processResponse } from '../../../util/service-util';
import { IAdsTypeInfo, ICustomerCustomPricing } from './ads-checkout-type';
import { getMockAdsTypeInfo, getMockCustomerCustomPricing } from './ads-mock-data';

const isStub = process.env.REACT_APP_STUB === 'true';

export const getAdsTypeInfo = isStub
  ? () => Promise.resolve(getMockAdsTypeInfo())
  : () => axios.get<IAdsTypeInfo[]>(`/api/ads/types`).then(response => processResponse(response));

export const getCustomerCustomPricing = isStub
  ? (customerId: string) => Promise.resolve(getMockCustomerCustomPricing(customerId))
  : (customerId: string) =>
      axios
        .get<ICustomerCustomPricing>(`/api/ads/customerPricingV2`, { params: { customerId } })
        .then(response => processResponse(response));



// WEBPACK FOOTER //
// ./src/modules/ads-checkout/parts/ads-checkout-service.ts